import App from '@/App.vue';
import router from '@/router';
import {createApp} from 'vue';
import i18n from "@/libs/locales";

import 'jquery/dist/jquery.min.js';
import "bootstrap"
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import '@/assets/css/Style.scss';
import '@/assets/css/Style.css';

const app = createApp(App);
app.use(i18n);
app.use(router);

app.mount('#app');
